var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2484 11.1517L15.2484 5.1517C14.7792 4.6825 14.0208 4.6825 13.5516 5.1517C13.0824 5.6209 13.0824 6.3793 13.5516 6.8485L17.5032 10.8001H3.60002C2.93642 10.8001 2.40002 11.3377 2.40002 12.0001C2.40002 12.6625 2.93642 13.2001 3.60002 13.2001H17.5032L13.5516 17.1517C13.0824 17.6209 13.0824 18.3793 13.5516 18.8485C13.7856 19.0825 14.0928 19.2001 14.4 19.2001C14.7072 19.2001 15.0144 19.0825 15.2484 18.8485L21.2484 12.8485C21.7176 12.3793 21.7176 11.6209 21.2484 11.1517",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.8c62beda5789df8d3689ee6d6ee0050b.svg";
export { ForwardRef as ReactComponent };